import React from 'react';

export const ActionBoxClear = ({ moveId, setUpdatedMoves, setEditedQuantities }) => {
  const handleClear = (e) => {
    e.stopPropagation();

    // Update the state that controls input values
    setUpdatedMoves((prev) => ({
      ...prev,
      [moveId]: {
        producing_quantity: '',
        damaged_quantity: '',
      },
    }));

    setEditedQuantities((prev) => ({
      ...prev,
      [moveId]: {
        producing_quantity: 0,
        damaged_quantity: 0,
      },
    }));
  };

  return (
    <div className="td-num" style={{ cursor: 'pointer' }} onClick={handleClear}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={17}
        height={17}
        viewBox="0 0 24 24"
        fill="none"
        stroke="#dc3545"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <line x1={18} y1={6} x2={6} y2={18} />
        <line x1={6} y1={6} x2={18} y2={18} />
      </svg>
    </div>
  );
};
